import {
  activityStatuses,
  basins,
  basinRoles,
  dataFormats,
  dataTypes,
  datasets,
  datums,
  domains,
  institutions,
  metadataStandards,
  parameters,
  people,
  projects,
  projectRoles,
  releaseStatuses,
  sites,
  siteStatuses,
  siteTypes,
  tasks,
  temporalFrequencies,
  updateFrequencies,
  updateTypes,
  variables,
} from "./entities/entity.index";

export const defaultTabs = ["basins", "datasets", "people", "projects", "sites"];

export const entities = {
  activityStatuses,
  basins,
  basinRoles,
  dataFormats,
  dataTypes,
  datasets,
  datums,
  domains,
  institutions,
  metadataStandards,
  parameters,
  people,
  projects,
  projectRoles,
  releaseStatuses,
  sites,
  siteStatuses,
  siteTypes,
  tasks,
  temporalFrequencies,
  updateFrequencies,
  updateTypes,
  variables,
};

export const initialDataExplorerState = {
  selectedRow: null,
  selectedEntity: "datasets",
  filters: {
    activityStatuses: {},
    basins: {},
    basinRoles: {},
    dataFormats: {},
    dataTypes: {},
    datasets: {},
    datums: {},
    domains: {},
    institutions: {},
    metadataStandards: {},
    parameters: {},
    people: {},
    projects: {},
    projectRoles: {},
    releaseStatuses: {},
    sites: {},
    siteStatuses: {},
    siteTypes: {},
    tasks: {},
    temporalFrequencies: {},
    updateFrequencies: {},
    updateTypes: {},
    variables: {},
  },
};

export const initialDataEditState = {
  isDatasetFormVisible: false,
  hasDataChanged: false,
  isAlertVisible: false,
};
